import { Service } from '@tino-frontend/adapters'
import {
  Bill,
  PayResponse,
  SnoozeSimulationResponse,
  BillSnoozeDetailsSnooze,
  BillList,
  BillListResponseV3,
  AddReferralSeller,
  RefundBalance,
} from '@types'
import { billListTransform } from './transformers/bill.transform'

export class BillService {
  constructor(private readonly http: Service) {
    this.http = http
  }

  async billList(companyId: string): Promise<BillList> {
    const response: BillListResponseV3 = await this.http.get(
      `/v4/company/${companyId}/bills`
    )
    return billListTransform(response)
  }

  async billListPast(
    companyId: string,
    dueDateStart: string,
    dueDateEnd: string
  ): Promise<BillList> {
    try {
      const response: BillListResponseV3 = await this.http.get(
        `/v1/company/${companyId}/past-bills?dueDateStart=${dueDateStart}&dueDateEnd=${dueDateEnd}`
      )
      return billListTransform(response)
    } catch (e) {
      return Promise.reject(e)
    }
  }

  async billDetail(companyId: string): Promise<Bill> {
    try {
      return await this.http.get(`/v2/company/${companyId}/home-bill`)
    } catch (e) {
      return Promise.reject(e)
    }
  }

  async refundBalance(companyId: string): Promise<RefundBalance> {
    return this.http.get(`/v1/company/${companyId}/balance`)
  }

  pay(
    company_id: string,
    bill_id: string,
    is_snooze: boolean,
    allow_boleto_creation?: boolean,
    allow_pix_creation?: boolean
  ): Promise<PayResponse> {
    return this.http.post(`/v1/company/${company_id}/bill/${bill_id}/pay`, {
      pay_snooze: is_snooze,
      allow_boleto_creation: Boolean(allow_boleto_creation),
      allow_pix_creation: Boolean(allow_pix_creation),
    })
  }

  payNextBill(
    company_id: string,
    allow_boleto_creation?: boolean,
    allow_pix_creation?: boolean
  ): Promise<PayResponse> {
    return this.http.post(`/v2/company/${company_id}/pay-next-bill`, {
      allow_boleto_creation: Boolean(allow_boleto_creation),
      allow_pix_creation: Boolean(allow_pix_creation),
    })
  }

  snoozeSimulation(
    companyId: string,
    billId: string
  ): Promise<SnoozeSimulationResponse> {
    return this.http.post(
      `/v1/company/${companyId}/bills/${billId}/snooze-simulation`
    )
  }

  acceptSnooze(companyId: string, financingId: string): Promise<void> {
    return this.http.post(
      `/v1/company/${companyId}/snooze-simulations/${financingId}/approve`
    )
  }

  getSnoozeDetails(
    companyId: string,
    financingDebtId: string
  ): Promise<BillSnoozeDetailsSnooze> {
    return this.http.get(
      `/v1/company/${companyId}/financing-debts/${financingDebtId}/snooze`
    )
  }

  getSnoozeDetailsByBillId(
    companyId: string,
    billId: string
  ): Promise<BillSnoozeDetailsSnooze> {
    return this.http.get(`/v1/company/${companyId}/bills/${billId}/snooze`)
  }

  addReferralSeller(
    companyId: string,
    addReferralSeller: AddReferralSeller
  ): Promise<void> {
    return this.http.post(
      `/v1/company/${companyId}/supplier-referral`,
      addReferralSeller
    )
  }
}
